(function () {
  function parseConfig(root) {
    var node = root.querySelector('[data-hold-quiz-config]');
    if (!node) return null;
    try {
      return JSON.parse(node.textContent);
    } catch (error) {
      return null;
    }
  }

  function money(currency, n) {
    return currency + (n % 1 === 0 ? n : n.toFixed(2));
  }

  function dispatchCartEvents() {
    ['cart:refresh', 'cart:build', 'cart:open'].forEach(function (name) {
      try {
        document.documentElement.dispatchEvent(new CustomEvent(name, { bubbles: true }));
      } catch (error) {
        var evt = document.createEvent('CustomEvent');
        evt.initCustomEvent(name, true, true, {});
        document.documentElement.dispatchEvent(evt);
      }
    });
  }

  function paintMist(svg) {
    if (!svg) return;
    var seed = 20260920;
    var rnd = function () {
      seed = (seed * 16807) % 2147483647;
      return seed / 2147483647;
    };
    var parts = [
      '<defs><filter id="holdQuizSoft" x="-5%" y="-20%" width="110%" height="140%">',
      '<feGaussianBlur stdDeviation="0.7"/></filter></defs><g filter="url(#holdQuizSoft)">'
    ];
    for (var i = 0; i < 2200; i++) {
      var t = Math.pow(rnd(), 0.55);
      var x = t * 1004 - 2;
      var y = 48 + (rnd() - 0.5) * (88 - 40 * Math.pow(t, 1.5));
      var fall = 1 - Math.abs(y - 50) / 54;
      var r = 0.42 + rnd() * (0.5 + 1.05 * t);
      var o = (0.07 + 0.5 * t) * (0.35 + rnd() * 0.65) * Math.max(fall, 0.15);
      parts.push(
        '<circle cx="' +
          x.toFixed(1) +
          '" cy="' +
          y.toFixed(1) +
          '" r="' +
          r.toFixed(2) +
          '" fill="#1E3A28" opacity="' +
          o.toFixed(3) +
          '"/>'
      );
    }
    parts.push('</g>');
    svg.innerHTML = parts.join('');
  }

  function initHoldQuiz(root) {
    if (!root || root.dataset.holdQuizReady === 'true') return;
    root.dataset.holdQuizReady = 'true';

    var CONFIG = parseConfig(root);
    if (!CONFIG) return;

    var currency = CONFIG.currency || '$';
    var softAt = typeof CONFIG.softAt === 'number' ? CONFIG.softAt : -2;
    var strongAt = typeof CONFIG.strongAt === 'number' ? CONFIG.strongAt : 2;
    var copy = CONFIG.copy || {};
    var soft = CONFIG.soft || {};
    var strong = CONFIG.strong || {};
    var both = CONFIG.both || {};
    var cartAddPath =
      (window.Shopify && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root
        : '/') + 'cart/add.js';

    var answers = [];
    var questionSteps = Array.prototype.slice.call(
      root.querySelectorAll('.hold-quiz__step[data-question-step]')
    );
    var questionCount = questionSteps.length || 1;
    root.style.setProperty('--hq-question-count', String(questionCount));

    questionSteps.forEach(function (step, index) {
      step.setAttribute('data-step-panel', String(index + 1));
      var back = step.querySelector('[data-hold-quiz-back]');
      if (!back) return;
      if (index === 0) {
        back.classList.add('hold-quiz__back--placeholder');
        back.setAttribute('tabindex', '-1');
        back.setAttribute('aria-hidden', 'true');
      } else {
        back.classList.remove('hold-quiz__back--placeholder');
        back.removeAttribute('tabindex');
        back.removeAttribute('aria-hidden');
      }
    });

    var ofLabel = root.querySelector('[data-hold-quiz-of]');
    if (ofLabel) {
      ofLabel.textContent = String(questionCount).padStart(2, '0');
    }

    var softPriceEl = root.querySelector('[data-price="soft"]');
    var strongPriceEl = root.querySelector('[data-price="strong"]');
    var bothPriceEl = root.querySelector('[data-price="both"]');
    var bothCompareEl = root.querySelector('[data-compare-price="both"]');
    if (softPriceEl) softPriceEl.textContent = money(currency, Number(soft.price) || 0);
    if (strongPriceEl) strongPriceEl.textContent = money(currency, Number(strong.price) || 0);
    if (bothPriceEl) {
      bothPriceEl.textContent = money(currency, Number(both.price) || 0);
    }
    if (bothCompareEl) {
      var comparePrice = Number(both.comparePrice);
      var regularPrice = Number(both.price) || 0;
      if (comparePrice && comparePrice > regularPrice) {
        bothCompareEl.textContent = money(currency, comparePrice);
        bothCompareEl.hidden = false;
      } else {
        bothCompareEl.textContent = '';
        bothCompareEl.hidden = true;
      }
    }

    paintMist(root.querySelector('[data-mist]'));

    var compareMount = root.querySelector('[data-compare-rows]');
    var compareSource = root.querySelector('[data-hold-quiz-compare]');
    if (compareMount && compareSource) {
      compareMount.appendChild(compareSource);
    } else if (compareMount) {
      Array.prototype.slice
        .call(root.querySelectorAll('.hold-quiz__steps > .hold-quiz__row'))
        .forEach(function (row) {
          compareMount.appendChild(row);
        });
    }

    var panels = {};
    root.querySelectorAll('[data-step-panel]').forEach(function (el) {
      panels[el.getAttribute('data-step-panel')] = el;
    });

    function updateRail(step) {
      var railFill = root.querySelector('[data-rail-fill]');
      if (!railFill) return;
      if (step === 'result') {
        railFill.style.width = '100%';
        return;
      }
      var n = parseInt(step, 10) || 1;
      railFill.style.width = (n / questionCount) * 100 + '%';
    }

    function goTo(step) {
      root.dataset.step = String(step);
      Object.keys(panels).forEach(function (key) {
        panels[key].setAttribute('aria-hidden', String(key !== String(step)));
      });
      var now = root.querySelector('[data-now]');
      if (now && step !== 'result') {
        now.textContent = String(step).padStart(2, '0');
      }
      updateRail(step);
      var focusTarget = panels[String(step)] && panels[String(step)].querySelector('.hold-quiz__opt, .hold-quiz__verdict');
      if (focusTarget && document.activeElement !== document.body) {
        if (focusTarget.classList.contains('hold-quiz__verdict')) {
          focusTarget.setAttribute('tabindex', '-1');
        }
        focusTarget.focus({ preventScroll: true });
      }
    }

    questionSteps.forEach(function (panel, index) {
      var stepNum = index + 1;
      panel.querySelectorAll('.hold-quiz__opt').forEach(function (opt) {
        opt.addEventListener('click', function () {
          answers[index] = {
            w: parseInt(opt.getAttribute('data-weight'), 10) || 0,
            chip: opt.getAttribute('data-chip') || ''
          };
          panel.querySelectorAll('.hold-quiz__opt').forEach(function (o) {
            o.setAttribute('aria-pressed', String(o === opt));
          });
          if (index < questionCount - 1) goTo(stepNum + 1);
          else finish();
        });
      });

      var back = panel.querySelector('[data-hold-quiz-back]:not(.hold-quiz__back--placeholder)');
      if (back) {
        back.addEventListener('click', function () {
          goTo(stepNum - 1);
        });
      }
    });

    function finish() {
      var score = answers.reduce(function (sum, item) {
        return sum + (item ? item.w : 0);
      }, 0);
      var pick = score <= softAt ? 'soft' : score >= strongAt ? 'strong' : 'both';
      var pickedCopy = copy[pick] || { verdict: '', why: '' };

      var verdictEl = root.querySelector('[data-verdict]');
      var whyEl = root.querySelector('[data-why]');
      if (verdictEl) verdictEl.innerHTML = pickedCopy.verdict || '';
      if (whyEl) whyEl.textContent = pickedCopy.why || '';

      var chips = root.querySelector('[data-chips]');
      if (chips) {
        chips.innerHTML = '';
        answers.forEach(function (answer) {
          if (!answer || !answer.chip) return;
          var span = document.createElement('span');
          span.className = 'hold-quiz__chip';
          span.textContent = answer.chip;
          chips.appendChild(span);
        });
      }

      root.querySelectorAll('[data-pin]').forEach(function (pin) {
        pin.classList.toggle('is-lit', pick === 'both' || pin.getAttribute('data-pin') === pick);
      });

      var recs = root.querySelector('[data-recs]');
      if (recs) recs.dataset.single = String(pick !== 'both');
      var softRec = root.querySelector('[data-rec="soft"]');
      var strongRec = root.querySelector('[data-rec="strong"]');
      var bothCta = root.querySelector('[data-both-cta]');
      if (softRec) softRec.hidden = pick === 'strong';
      if (strongRec) strongRec.hidden = pick === 'soft';
      if (bothCta) bothCta.hidden = pick !== 'both';

      goTo('result');
    }

    var restart = root.querySelector('[data-hold-quiz-restart]');
    if (restart) {
      restart.addEventListener('click', function () {
        answers = [];
        root.querySelectorAll('.hold-quiz__opt').forEach(function (opt) {
          opt.removeAttribute('aria-pressed');
        });
        var more = root.querySelector('.hold-quiz__more');
        if (more) more.open = false;
        goTo(1);
      });
    }

    function productFor(key) {
      if (key === 'both') return both;
      if (key === 'strong') return strong;
      return soft;
    }

    function items(key) {
      var product = productFor(key);
      return [{ id: product.variantId, quantity: 1 }];
    }

    function setErr(key, html, isNote) {
      var el = root.querySelector('[data-err="' + key + '"]');
      if (!el) return;
      el.innerHTML = html || '';
      el.classList.toggle('is-on', !!html);
      el.classList.toggle('is-note', !!isNote);
    }

    root.querySelectorAll('[data-add]').forEach(function (btn) {
      var key = btn.getAttribute('data-add');
      btn.dataset.reset = btn.innerHTML;

      btn.addEventListener('click', function () {
        setErr(key, '');
        var product = productFor(key);
        var list = items(key);

        if (
          list.some(function (item) {
            return !item.id;
          })
        ) {
          if (product.url) window.location.href = product.url;
          else setErr(key, 'Product unavailable.', true);
          return;
        }

        btn.disabled = true;
        btn.classList.add('is-busy');
        btn.textContent = 'Adding…';

        fetch(cartAddPath, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({ items: list })
        })
          .then(function (res) {
            if (!res.ok) throw new Error('cart');
            return res.json();
          })
          .then(function () {
            btn.classList.remove('is-busy');
            btn.classList.add('is-added');
            btn.textContent = 'Added to bag';
            dispatchCartEvents();
            setTimeout(function () {
              btn.classList.remove('is-added');
              btn.innerHTML = btn.dataset.reset;
              btn.disabled = false;
            }, 4000);
          })
          .catch(function () {
            btn.classList.remove('is-busy');
            btn.disabled = false;
            btn.innerHTML = btn.dataset.reset;
            var url = product.url || '#';
            setErr(
              key,
              'That didn’t go through. Try again, or <a href="' + url + '">open the product page</a>.'
            );
          });
      });
    });

    goTo(1);
  }

  function initAll(scope) {
    var roots = (scope || document).querySelectorAll('[data-hold-quiz]');
    Array.prototype.forEach.call(roots, initHoldQuiz);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
